
const DoInitialCellMapping = {
	input: {
		buildingType: "Initial!B3",
		operationType: "Initial!B4",
		totalAmountInclVat: "Initial!B5",
		startYear: "Initial!B6",
		surface: "Initial!B7",
		habitationsCount: "Initial!B8",
		habitationsSize: "Initial!B9",
		socialLandlordRental: "Initial!B11",
		existingWarrantyRate: "Initial!B12",
		isNonPerformingContractor: "Initial!B13",
		isInReunionIsland: "Initial!B14",
		brokerCommission: "Initial!B17",
		brokerMinCommission: "Initial!B18",
		brokerFees: "Initial!B19",
	},
	output: {
		doPrimeHT: {
			cellReference: "Initial!G3",
			outputType: "price",
		},
		doPrimeTaxes: {
			cellReference: "Initial!H3",
			outputType: "price",
		},
		doPrimeTTC: {
			cellReference: "Initial!I3",
			outputType: "price",
		},
		existingDamagesPrimeHT: {
			cellReference: "Initial!G4",
			outputType: "price",
		},
		existingDamagesPrimeTaxes: {
			cellReference: "Initial!H4",
			outputType: "price",
		},
		existingDamagesPrimeTTC: {
			cellReference: "Initial!I4",
			outputType: "price",
		},
		cnrPrimeHT: { cellReference: "Initial!G5", outputType: "price" },
		cnrPrimeTaxes: { cellReference: "Initial!H5", outputType: "price" },
		cnrPrimeTTC: { cellReference: "Initial!I5", outputType: "price" },
		terrorismContributionPrimeHT: {
			cellReference: "Initial!G6",
			outputType: "price",
		},
		terrorismContributionPrimeTaxes: {
			cellReference: "Initial!H6",
			outputType: "price",
		},
		terrorismContributionPrimeTTC: {
			cellReference: "Initial!I6",
			outputType: "price",
		},
		duneManagementFeesHT: { cellReference: "Initial!G7", outputType: "price" },
		duneManagementFeesTaxes: {
			cellReference: "Initial!H7",
			outputType: "price",
		},
		duneManagementFeesTTC: { cellReference: "Initial!I7", outputType: "price" },
		intermediaryManagementFeesHT: {
			cellReference: "Initial!G8",
			outputType: "price",
		},
		intermediaryManagementFeesTaxes: {
			cellReference: "Initial!H8",
			outputType: "price",
		},
		intermediaryManagementFeesTTC: {
			cellReference: "Initial!I8",
			outputType: "price",
		},
		totalClientPrimeHT: { cellReference: "Initial!G9", outputType: "price" },
		totalClientPrimeTaxes: { cellReference: "Initial!H9", outputType: "price" },
		totalClientPrimeTTC: { cellReference: "Initial!I9", outputType: "price" },

		agreedRateHT: { cellReference: "Initial!G11", outputType: "percentage" },
		agreedRateTTC: { cellReference: "Initial!G12", outputType: "percentage" },

		brokerCommission: { cellReference: "Initial!G15", outputType: "price" },
		brokerRemuneration: { cellReference: "Initial!G16", outputType: "price" },
		totalClientPrimeWithoutBrokerRemuneration: {
			cellReference: "Initial!G17",
			outputType: "price",
		},

		duneNetCommission: { cellReference: "Initial!G19", outputType: "price" },
		duneNetRemuneration: { cellReference: "Initial!G20", outputType: "price" },
	},
};

export { DoInitialCellMapping };
